import {
  LayerListConfig,
  LayerListFunctionConfig,
} from '../../../app/config/model/layerlist-config.model';
import { LayerCode } from '../../../app/shared/enum/layer-code.enum';

export const LAYER_LIST_CONFIG: LayerListConfig = {
  layerList: [
    /*{
      fkLayer: LayerCode.parzellen_view,
      visible: false,
    },*/
    {
      fkLayer: LayerCode.geo_admin_zonenplan_harmonisiert,
      visible: false,
    },
    {
      fkLayer: LayerCode.grenzen,
      visible: false,
    },
    {
      fkLayer: LayerCode.av_webgis_ausland,
      visible: false,
    },
    {
      isGroupLayer: true,
      title: 'JSON_CONFIG.LAYERLIST.AMTLICHE_VERMESSUNG_GROUP',
      visible: true,
      layers: [
        {
          fkLayer: LayerCode.av_webgis_sw_liegenschaften,
          visible: false,
        },
        {
          fkLayer: LayerCode.av_webgis_sw_vector_tile,
          visible: true,
        },
      ],
    },
    {
      isGroupLayer: true,
      title: 'JSON_CONFIG.LAYERLIST.BAHNPLAN',
      visible: true,
      layers: [
        {
          fkLayer: LayerCode.dgp_bahnplan,
          visible: true,
        },
        {
          fkLayer: LayerCode.bahnhof_und_ausruestung,
          visible: true,
        },
        {
          fkLayer: LayerCode.dgp_ingenieurbau,
        },
        {
          fkLayer: LayerCode.energie,
          visible: true,
        },
      ],
    },
    {
      fkLayer: LayerCode.streckennetz,
      visible: true,
    },
    {
      fkLayer: LayerCode.mbul_bauvorhaben,
      visible: false,
    },
    {
      isGroupLayer: true,
      title: 'JSON_CONFIG.LAYERLIST.UMWELT',
      visible: true,
      layers: [
        {
          fkLayer: LayerCode.altlasten,
        },
        {
          fkLayer: LayerCode.gs_gewaesser,
        },
        {
          fkLayer: LayerCode.stoerfallpunkte,
        },
      ],
    },
    {
      fkLayer: LayerCode.isos,
      visible: false,
    },
    {
      fkLayer: LayerCode.denkmalpflege,
      visible: false,
    },
    {
      fkLayer: LayerCode.gebaeude,
      visible: false,
    },
    {
      isGroupLayer: true,
      title: 'JSON_CONFIG.LAYERLIST.LEITUNGSKATASTER',
      visible: false,
      layers: [
        {
          fkLayer: LayerCode.dgp_leitungskataster,
          visible: true,
        },
        {
          fkLayer: LayerCode.dgp_leitungendritter,
          visible: true,
        },
      ],
    },
    {
      fkLayer: LayerCode.energie_mbul,
      visible: false,
    },
    {
      fkLayer: LayerCode.sap,
      visible: false,
    },
    {
      fkLayer: LayerCode.nutzflaeche_infra,
      visible: false,
    },
    {
      fkLayer: LayerCode.areale_view,
      visible: false,
    },
    {
      fkLayer: LayerCode.strategieflaeche,
      visible: false,
    },
    {
      fkLayer: LayerCode.verkaufsobjekte,
      visible: false,
    },
    {
      fkLayer: LayerCode.parzellen,
      visible: false,
    },
    /*{
      fkLayer: LayerCode.f_parzellen,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_teilparzelle,
      visible: false,
    },*/
    {
      fkLayer: LayerCode.f_public_verkaufsobjekte,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_public_strategieflaeche,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_public_nutzflaeche,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_public_areale,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_verkaufsobjekte,
      visible: false,
      checkViewer: true,
    },
    {
      fkLayer: LayerCode.f_public_sap_mietertraege,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_public_mast,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_public_abschnitt,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_public_trasse,
      visible: false,
    },
    /*{
      fkLayer: LayerCode.f_parzelle_Locate_view,
      visible: false,
    },
    {
      fkLayer: LayerCode.f_teilparzelle_Locate_view,
      visible: false,
    },*/
  ],
};

export const LAYER_LIST_FUNCTION_CONFIG: LayerListFunctionConfig = {
  functionList: [
    {
      fkId: 'infoLegendZonenplan',
      imageUrl: 'assets/images/Legende_Zonenplan.png',
    },
    {
      fkId: 'infoLegendEisbahnN',
      imageUrl:
        'assets/images/ch.bav.laermbelastung-eisenbahn_tatsaechliche_emissionen_nacht_de.png',
    },
    {
      fkId: 'infoLegendSwisscom',
      imageUrl: 'assets/images/swisscom_legende.png',
    },
  ],
};
